export class OpportunityCriteria {
  search: string = null;
  accountOwnerId: string = null;
  sourcingSpecialistId: string = null;
  opportunityStatusId: string = null;
  salesAgentId: string = null;
  from: string = null;
  to: string = null;
  departureDate = null;
}
